import { Utils__getImeiMd5, Utils__getDeviceInfo, Utils__getUserAccountInfo, Utils__isMiWebViewSDK } from './utils';

/**
 * 初始化一个 A/B Test；客户端维度划分；默认为 A/B 各为 50%
 *
 * @author 文桥 <wenqiao1@xiaomi.com>
 * @param {*} key
 * @param {number} [abtestRate=0.5]
 * @returns
 */
function initOneABTest(key, abtestRate = 0.5) { // eslint-disable-line
  const nextKey = `__ABTEST__${key}`;

  try {
    const originValue = localStorage[nextKey];
    if (originValue) {
      return Number(originValue);
    }

    const isabtest = Number.EPSILON
      ? abtestRate - Math.random() <= Number.EPSILON
      : Math.random() <= abtestRate;
    localStorage[nextKey] = isabtest ? '1' : '0';
    return Number(localStorage[nextKey]);
  } catch (e) { // eslint-disable-line
    return false;
  }
}

export default function initFmonitor(pid, pname, options = {}) {
  const imeiMd5 = Utils__getImeiMd5();
  const deviceInfo = Utils__getDeviceInfo() || {};
  const userInfo = Utils__getUserAccountInfo() || {};

  window.mfm = window.mfm || {};
  window.mfm.queue = [];
  window.mfm.send = function (data) {
    const type = (data.type || 'GET').toLowerCase();

    if (window.mfm.logger && window.mfm.logger[type]) {
      return window.mfm.logger[type](data.body, data.url);
    }

    window.mfm.queue.push(data);
    return false;
  };

  const abtestVisibleMonitor = initOneABTest('visibleMonitor');
  const webviewExpid = Utils__isMiWebViewSDK() ? 'MiWebViewSDK' : 'WebView';
  window.mfm.config = {
    // disabled: true, // 禁用日志上报功能
    appid: pid,
    appname: pname,
    isVisibleMonitor: abtestVisibleMonitor,
    onajax: false,
    page: false,
    sampleRate: 100, // 统计抽样率
    siteSpeedSampleRate: options.siteSpeedSampleRate || 100, // 网站速度抽样率
    expires: options.expires || 2 * 24 * 60 * 60 * 1000,
    resource: {
      timeout: 2000,
      imgTimeout: 3000,
    },
    logger: {
      url: 'https://r.browser.miui.com/log/uploadApiLog',
      methods: 'GET',
      body: {
        imei: imeiMd5 || '',
        // uid: userInfo.user_id || '',
        did: deviceInfo.device_hash || '',
        oaid: deviceInfo.oaId || deviceInfo.oaid,
        appVersion: deviceInfo.package_name || '',
        appName: deviceInfo.version_name || '',
        expid: webviewExpid,
        abtestid: abtestVisibleMonitor ? 'IsVisibleMonitor' : 'AllMonitor',
        chanel: deviceInfo.channel || '',
      }
    }
  };

  loadScript('https://ssl-cdn.static.browser.mi-img.com/feed/sdk/fmonitor/index.min.js');
}

function loadScript(src, id, defer = true) {
  if (src) {
    const scr = window.document.createElement('script');

    scr.type = 'text/javascript';
    scr.defer = defer;
    scr.src = src;
    scr.crossorigin = 'anonymous';

    if (id) {
      scr.id = id;
    }

    const $head = window.document.getElementsByTagName('head')[0];

    $head && $head.appendChild && $head.appendChild(scr);
  }
}


